module.exports = __webpack_public_path__ + "static/media/adv-banner-img3.36195b7f.png";